// extracted by mini-css-extract-plugin
export default {"headerBar":"HeaderBar_headerBar__j42-I","text":"HeaderBar_text__FMrgB"};